<template>
  <div id="patients">
    <div class="mb-2 wrrapper">
      <page-heading title="Queue Report's"></page-heading>
      <div class="flex justify-end mr-2">
        <SmartFilter @apply="onApplyFilters" @reset="onResetFilters">
          <template #button>
            <span>Show Filters</span>
          </template>
          <div class="filter-row">
            <DateRangePicker @update="updateDate" style="flex: 1;" />
          </div>
          <div class="filter-row">
            <Select
              :options="['In-Queue', 'Processed']"
              placeholder="Filter by"
              styles="custom-sort mr-1"
              :input="handleFilter"
              style="flex: 1;"
            />
            <Select
              placeholder="Filter by doctors"
              :loading="isLoading"
              class="mr-1"
              :options="filterItems"
              :input="filterByDoctors"
              style="flex: 1;"
            />
          </div>
          <div class="filter-row">
            <Select
              :options="servicesList"
              placeholder="Filter by services"
              styles="custom-sort mr-1"
              :input="handleServices"
              :loading="isLoading"
              style="flex: 1;"
            />
            <Select
              placeholder="Filter By Service Name"
              class="mr-1"
              :loading="isLoading"
              :options="
                listServices.map(item => ({
                  id: item.serviceId,
                  name: item.service.name
                }))
              "
              :input="filterByServiceName"
              style="flex: 1;"
            />
          </div>
          <div class="filter-row" v-if="isAdmin">
            <Select
              class="ml-1"
              styles="expenses-select"
              placeholder="Filter by Branch"
              :input="handleBranchChange"
              :options="brachData"
              style="flex: 1;"
            />
          </div>
        </SmartFilter>
        <ExportButtons
          class="ml-2"
          @pdf="handleExportPdf"
          @excel="handleExportExcel"
        />
      </div>
      <data-table
        id="print-que"
        :cols="columns"
        :rows="queueReports"
        height="calc(76vh)"
        :loading="isQueueReportsLoading"
      >
        <template slot="action" slot-scope="{ actions }">
          <div class="patient-process">
            <a
              :class="actions.historyStatus == 4 ? 'canceled' : ''"
              href="#"
              @click="handlePatinetId(actions)"
              >{{
                actions.historyStatus == 1
                  ? "Go →"
                  : actions.historyStatus == 4
                  ? "Canceled"
                  : "Process →"
              }}</a
            >
          </div>
        </template>
      </data-table>
    </div>
    <ConfirmDialog
      name="confirmModal"
      title="Process patient"
      message="Are you sure you want to process this patient?"
      confirm-text="Yes, process"
      cancel-text="Cancel"
      @confirm="handleSave"
      @cancel="handleCancel"
    />
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import Select from "@/components/Select";
import ConfirmDialog from "@/components/ConfirmDialog";
import DateRangePicker from "@/components/DateRangePIcker";
import SmartFilter from "@/components/SmartFilter.vue";
import { mapGetters, mapActions } from "vuex";
import { formatedDate } from "@/utils/helpers";
import ExportButtons from "@/components/ExportButtons.vue";
import { exportReportPdf, exportReportExcel } from "@/utils/reportExport";
import { api } from "@/axios";
import { getBranchLogo } from "../../utils/helpers";
import { permissionsMiddleWare } from "../../utils/permissionsMiddleWare";
export default {
  components: {
    DateRangePicker,
    DataTable,
    Select,
    ConfirmDialog,
    SmartFilter,
    ExportButtons
  },
  data() {
    return {
      isLoading: false,
      registrationId: "",
      filterData: {
        start_date: formatedDate(),
        end_date: formatedDate(),
        status: undefined,
        service_head_id: undefined,
        service_name_id: undefined,
        branchId: null
      },
      id: "",
      historyId: "",
      brachData: [],
      isAdmin: null,
      columns: [
        { column: "serial", label: "#", width: "60" },
        { column: "name", label: "Patient Name", sortable: true },
        { column: "contactNumber", label: "Phone No", sortable: true },
        { column: "mr_no", label: "Mr Number", sortable: true },
        { column: "service_name", label: "Service", sortable: true },
        { column: "reffered_to", label: "Referred To", sortable: true },
        { column: "created_at", label: "Created At", sortable: true },
        { column: "updated_at", label: "Performed At", sortable: true },
        { column: "action", label: "Actions" }
      ]
    };
  },
  methods: {
    ...mapActions("receptionist", ["cancelAppointment", "getQueueReports"]),
    ...mapActions({
      doctorList: "doctors/doctorList",
      doctors: "receptionist/listDoctors",
      currentSelectBranch: "expenses/currentSelectBranch"
    }),
    ...mapActions("expenses", ["fetchBranch"]),
    handleSave() {
      if (permissionsMiddleWare("Get Updated History")) {
        this.$router.push({ name: "PatientDetails", params: { id: this.id } });
        api
          .get(`/history/history-update/${this?.historyId}`)
          .then(res => {
            if (res?.data?.result?.affected === 1) {
              this.$toasted.show("Status changed sucessfully").goAway("3000");
            } else {
              this.$toasted.show("Status changed sucessfully").goAway("3000");
            }
          })
          .catch(() => {
            this.$toasted.show("Status didn't changed").goAway("3000");
          });
        this.$modal.hide("confirmModal");
      } else {
        this.$toasted.info(
          "This action cannot be performed by you due to insufficient authorization. Action : Get Updated History",
          { duration: 3000 }
        );
      }
    },
    handleCancel() {
      this.$modal.hide("confirmModal");
      this.id = "";
    },
    filterByDoctors(val) {
      const id = val && val.id !== null ? val.id : "";
      this.filterData.doctor_id = id;
      this.getQueueReports(this.filterData);
    },
    handlePatinetId(actions) {
      const userId = this.userInfo && this.userInfo?.id;
      const payload = {
        status: 1,
        userId: userId,
        historyId: actions.historyId
      };
      if (actions.historyStatus == 2) {
        this.cancelAppointment({ id: actions.id, payload });
      }
      if (actions.historyStatus == 1) {
        this.$router.push({
          name: "PatientDetails",
          params: { id: actions.id }
        });
      } else {
        this.$modal.show("confirmModal");
        this.id = actions.id;
        this.historyId = actions.historyId;
      }
    },
    filterByServiceName(val) {
      if (val) {
        this.filterData.service_name_id = val.id;
        this.getQueueReports(this.filterData);
      } else {
        this.filterData.service_name_id = undefined;
        this.getQueueReports(this.filterData);
      }
    },
    updateDate(val) {
      if (val) {
        (this.filterData.start_date = val.startDate),
          (this.filterData.end_date = val.endDate),
          this.getQueueReports(this.filterData);
      }
    },
    handleServices(val) {
      if (val) {
        this.filterData.service_head_id = val.id;
        this.getQueueReports(this.filterData);
      } else {
        this.filterData.service_head_id = undefined;
        this.getQueueReports(this.filterData);
      }
    },
    handleFilter(val) {
      if (val == "Processed") {
        this.filterData.status = 1;
        this.getQueueReports(this.filterData);
      } else if (val == "In-Queue") {
        this.filterData.status = 2;
        this.getQueueReports(this.filterData);
      } else {
        this.filterData.status = null;
        this.getQueueReports(this.filterData);
      }
    },
    handleBranchChange(val) {
      if (val && val != null) {
        this.getQueueReports({
          start_date: this.filterData.start_date,
          end_date: this.filterData.end_date,
          branchId: val.key
        });
      }
      if (val === null) {
        this.getQueueReports({
          start_date: formatedDate(),
          end_date: formatedDate(),
          branchId: null
        });
      }
    },
    exportInput() {
      return {
        title: "Queue Report",
        dateRange: {
          start: this.filterData.start_date,
          end: this.filterData.end_date
        },
        printedBy: this.userInfo && this.userInfo.full_name,
        businessLogoUrl: this.userInfo && this.userInfo.bussinessLogoUrl,
        branchLogoUrl: this.getBranchUrl,
        cols: this.columns,
        rows: this.queueReports,
        fileName: "queue-report"
      };
    },
    handleExportPdf() {
      exportReportPdf(this.exportInput());
    },
    handleExportExcel() {
      exportReportExcel(this.exportInput());
    },
    onApplyFilters() {
      this.getQueueReports(this.filterData);
    },
    onResetFilters() {
      this.filterData = {
        start_date: this.formatedDate(),
        end_date: this.formatedDate(),
        status: undefined,
        service_head_id: undefined,
        service_name_id: undefined,
        branchId: null
      };
      this.getQueueReports(this.filterData);
    }
  },
  computed: {
    ...mapGetters({
      queueReports: "receptionist/queueReports",
      isQueueReportsLoading: "receptionist/isQueueReportsLoading",
      listDoctors: "doctors/listDoctors",
      listServices: "services/listItems",
      userInfo: "auth/userInfo",
      isOther: "auth/isOther",
      doctorsList: "receptionist/doctorsList",
      fetchUserBranch: "expenses/fetchUserBranch",
      selectedBranch: "expenses/selectedBranch"
    }),
    ...mapGetters({ listDoctors: "doctors/listDoctors" }),
    getBranchUrl() {
      return this.selectedBranch;
    },
    filterItems() {
      return this.doctorsList.map(item => ({
        name: item.full_name,
        id: item.id
      }));
    },
    servicesList() {
      return (
        this.listDoctors &&
        this.listDoctors.map(item => ({
          id: item.id,
          name: item.name
        }))
      );
    }
  },
  async mounted() {
    await this.fetchBranch();
    this.isAdmin = this.userInfo.userRole.some(({ name }) => name === "admin");
    this.getQueueReports({
      start_date: formatedDate(),
      end_date: formatedDate(),
      branchId: null
    });
    this.$store.dispatch("services/listServices", this.isOther);
    this.isLoading = true;
    this.doctorList("servicehead")
      .then(() => (this.isLoading = false))
      .catch(() => (this.isLoading = false));
    await this.fetchUserBranch?.map(elem => {
      this.brachData.push({ name: elem.name, key: elem.id });
    });
    const object = getBranchLogo(
      this.fetchUserBranch,
      this.userInfo?.userBranchId
    );
    this.currentSelectBranch(object);
    this.doctors();
  }
};
</script>

<style>
#patients .footer {
  margin-right: 30px !important;
}

.date-filter .custom-datepicker {
  margin-top: 0;
}

.patient-process {
  width: 7rem !important;
}

.patient-process a {
  background: var(--grad-accent);
  padding: 0.33rem 0.7rem;
  border-radius: var(--radius-sm);
  color: #fff;
  font-size: var(--fs-sm);
  font-weight: 500;
  transition: filter var(--dur) var(--ease);
}

.patient-process a:hover {
  filter: brightness(0.9);
}

.canceled {
  pointer-events: none;
  opacity: 0.9;
}

.filter-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
</style>
